import React, { Component } from 'react';
import LeadListHeader from './LeadListHeader';
import LeadsLine from './LeadsLine';

class SectionList extends Component {

	state = {
		hidden: [false, false, false] // TODO make more dynamic
	}

	render() {
		return (
			<div> {this.display()} </div>
		);
	}

	display = () => {
		const { sections } = this.props;

		return sections.map((section, index) => {
			return (
				<div>
					<LeadListHeader section={section} hideSection={this.hideSection} index={index} />
					{!this.state.hidden[index] ? this.lines(section.data) : null}
				</div>
			)
		})
	}

	hideSection = (index) => {
		let tmp = this.state.hidden;
		tmp[index] = !tmp[index];
		this.setState({
			hidden: tmp
		})
	}
	lines = (data) => {

		if (data == null || data.length == 0)
			return <div>No Items</div>

		return data.map(
			(lead) => {
				return <LeadsLine lead={lead} gotoEditLead={this.props.gotoEditLead} />
			})

	}
}
export default SectionList;


// WEBPACK FOOTER //
// ./src/components/leadtracker/SectionList.js